import { PartnerSettings } from 'utils/partnerSettings';
import { publicInstance } from './instance';

export const getPartnershipBranding = async (partnershipId: string): Promise<PartnerSettings> => {
  const { data } = await publicInstance.get<PartnerSettings>(`partnerships/${partnershipId}/branding`);

  return data;
};
